"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var exceptions_1 = require("@ikea-aoa/exceptions");
var ServiceFetch_1 = __importDefault(require("../../../utilities/ServiceFetch"));
var ChinaAuthenticationServiceCookieNameEnum_1 = __importDefault(require("./ChinaAuthenticationServiceCookieNameEnum"));
/**
 * This service is used for handling authentication in China.
 */
var ChinaAuthenticationService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.refreshTokenEndpoint
     * @param options.loginPageEndpoint
     * @param options.refreshTokenEndpoint
     * @param options.loginPageEndpoint
     */
    function ChinaAuthenticationService(options) {
        this.loginIntervalTime = 500;
        this.refreshTokenEndpoint = null;
        this.loginPageEndpoint = null;
        this.refreshTokenEndpoint = options.refreshTokenEndpoint;
        this.loginPageEndpoint = options.loginPageEndpoint;
    }
    /**
     * Authenticates and returns token.
     *
     * @returns Promise.
     */
    ChinaAuthenticationService.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, refreshToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accessToken = this.getCookie(ChinaAuthenticationServiceCookieNameEnum_1.default.accessToken);
                        refreshToken = this.getCookie(ChinaAuthenticationServiceCookieNameEnum_1.default.refreshToken);
                        if (!accessToken) return [3 /*break*/, 1];
                        return [2 /*return*/, accessToken];
                    case 1:
                        if (!refreshToken) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.refreshAccessToken(refreshToken)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [4 /*yield*/, this.login()];
                    case 4: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Request the user to login.
     *
     * @returns Access token.
     */
    ChinaAuthenticationService.prototype.login = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.removeCookie(ChinaAuthenticationServiceCookieNameEnum_1.default.accessToken);
            _this.removeCookie(ChinaAuthenticationServiceCookieNameEnum_1.default.refreshToken);
            var popup = window.open(_this.loginPageEndpoint);
            var interval = setInterval(function () {
                var accessToken = _this.getCookie(ChinaAuthenticationServiceCookieNameEnum_1.default.accessToken);
                if (accessToken) {
                    clearInterval(interval);
                    popup.close();
                    resolve(accessToken);
                }
                else if (popup.closed) {
                    reject(new exceptions_1.ServiceException('Failed to login. The popup was closed.'));
                }
            }, _this.loginIntervalTime);
        });
    };
    /**
     * Refreshes the access token.
     *
     * @param refreshToken Refresh token.
     * @returns Access token.
     */
    ChinaAuthenticationService.prototype.refreshAccessToken = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.refreshTokenEndpoint, {
                            method: 'post',
                            credentials: 'same-origin',
                            headers: {
                                'content-type': 'application/json',
                                'x-client-channel': 'WEB',
                                'x-client-platform': 'PcWeb',
                                source: 'PLANNER'
                            },
                            body: JSON.stringify({
                                refreshToken: refreshToken
                            })
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response['data'] && response['code']) {
                            if (response['code'] === 'InvalidParameter.Refresh.Token.Error') {
                                return [2 /*return*/, this.login()];
                            }
                            throw new exceptions_1.ServiceException("Failed to refresh access token. Error: " + response['code']);
                        }
                        this.setCookie(ChinaAuthenticationServiceCookieNameEnum_1.default.accessToken, response['data']['id_token'], response['data']['expires_in'] * 1000);
                        return [2 /*return*/, response['data']['id_token']];
                }
            });
        });
    };
    /**
     * Removes a cookie.
     *
     * @param name Name.
     */
    ChinaAuthenticationService.prototype.removeCookie = function (name) {
        this.setCookie(name, '', -1000);
    };
    /**
     * Sets a cookie.
     *
     * @param name Name.
     * @param value Value.
     * @param expiresIn Expires in.
     */
    ChinaAuthenticationService.prototype.setCookie = function (name, value, expiresIn) {
        var date = new Date();
        date.setTime(date.getTime() + expiresIn);
        document.cookie = name + "=" + value + "; path=/; expires=" + date.toUTCString() + ";";
    };
    /**
     * Returns a cookie.
     *
     * @param name Name.
     * @returns Cookie value.
     */
    ChinaAuthenticationService.prototype.getCookie = function (name) {
        var cookie = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        return cookie ? cookie.pop() : null;
    };
    return ChinaAuthenticationService;
}());
exports.default = ChinaAuthenticationService;
//# sourceMappingURL=ChinaAuthenticationService.js.map